import angular from 'angular';

import tszReportMenuActions from './tsz-report-menu-actions';

const tszReportMenuActionsModule = angular.module('tsz.components.tszReportMenuActions', [])
  .component('tszReportMenuActions', tszReportMenuActions);

export default tszReportMenuActionsModule;



// WEBPACK FOOTER //
// ./src/components/tsz-report-menu-actions/tsz-report-menu-actions.module.js